import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";
import * as Sentry from "@sentry/angular";

if (environment.production) {
  enableProdMode();
  Sentry.init({
    dsn: "https://45a7f5a6a9b848b4ba1788d7ce8e93e0@o525949.ingest.sentry.io/5646981",
    environment: environment.name,
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    tracePropagationTargets: [
      "https://www4.test.k8s.bigcct.be/api",
      "https://www.cullen-international.com/api",
    ],
    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1,
  });
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
